import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useNationalitiesStore = defineStore("nationalities", () => {
  const nacionalities = ref([
    { id: "12", nombre: "AFGANISTÁN" },
    { id: "2", nombre: "ALBANIA" },
    { id: "3", nombre: "ALEMANIA" },
    { id: "5", nombre: "ANDORRA" },
    { id: "6", nombre: "ANGOLA" },
    { id: "7", nombre: "ANGUILA" },
    { id: "8", nombre: "ANTIGUA Y BARBUDA" },
    { id: "9", nombre: "ANTILLAS NEERLANDESAS" },
    { id: "10", nombre: "ANTÁRTIDA" },
    { id: "11", nombre: "ARABIA SAUDITA" },
    { id: "4", nombre: "ARGELIA" },
    { id: "1", nombre: "ARGENTINA" },
    { id: "13", nombre: "ARMENIA" },
    { id: "14", nombre: "ARUBA" },
    { id: "15", nombre: "AUSTRALIA" },
    { id: "16", nombre: "AUSTRIA" },
    { id: "17", nombre: "AZERBAIYÁN" },
    { id: "18", nombre: "BAHAMAS" },
    { id: "20", nombre: "BANGLADESH" },
    { id: "21", nombre: "BARBADOS" },
    { id: "22", nombre: "BELICE" },
    { id: "23", nombre: "BENIN" },
    { id: "24", nombre: "BERMUDAS" },
    { id: "25", nombre: "BIELORRUSIA" },
    { id: "26", nombre: "BOLIVIA" },
    { id: "27", nombre: "BOSNIA Y HERZEGOVINA" },
    { id: "28", nombre: "BOTSWANA" },
    { id: "29", nombre: "BRASIL" },
    { id: "31", nombre: "BULGARIA" },
    { id: "32", nombre: "BURKINA FASO" },
    { id: "33", nombre: "BURUNDI" },
    { id: "34", nombre: "BUTÁN" },
    { id: "35", nombre: "BÉLGICA" },
    { id: "36", nombre: "CABO VERDE" },
    { id: "37", nombre: "CAMBOYA" },
    { id: "38", nombre: "CAMERÚN" },
    { id: "39", nombre: "CANADÁ" },
    { id: "40", nombre: "CHAD" },
    { id: "41", nombre: "CHILE" },
    { id: "42", nombre: "CHINA" },
    { id: "43", nombre: "CHIPRE" },
    { id: "44", nombre: "CIUDAD DEL VATICANO" },
    { id: "45", nombre: "COLOMBIA" },
    { id: "46", nombre: "COMORAS" },
    { id: "47", nombre: "COREA DEL NORTE" },
    { id: "48", nombre: "COREA DEL SUR" },
    { id: "50", nombre: "COSTA DE MARFIL" },
    { id: "49", nombre: "COSTA RICA" },
    { id: "51", nombre: "CROACIA" },
    { id: "52", nombre: "CUBA" },
    { id: "53", nombre: "DINAMARCA" },
    { id: "54", nombre: "DOMINICA" },
    { id: "55", nombre: "ECUADOR" },
    { id: "56", nombre: "EGIPTO" },
    { id: "57", nombre: "EL SALVADOR" },
    { id: "58", nombre: "EMIRATOS ÁRABES UNIDOS" },
    { id: "59", nombre: "ERITREA" },
    { id: "60", nombre: "ESLOVAQUIA" },
    { id: "61", nombre: "ESLOVENIA" },
    { id: "62", nombre: "ESPAÑA" },
    { id: "63", nombre: "ESTADOS UNIDOS" },
    { id: "64", nombre: "ESTONIA" },
    { id: "65", nombre: "ETIOPÍA" },
    { id: "66", nombre: "FILIPINAS" },
    { id: "67", nombre: "FINLANDIA" },
    { id: "68", nombre: "FIYI" },
    { id: "69", nombre: "FRANCIA" },
    { id: "71", nombre: "GAMBIA" },
    { id: "72", nombre: "GEORGIA" },
    { id: "73", nombre: "GHANA" },
    { id: "74", nombre: "GIBRALTAR" },
    { id: "75", nombre: "GRANADA" },
    { id: "76", nombre: "GRECIA" },
    { id: "77", nombre: "GROENLANDIA" },
    { id: "78", nombre: "GUADALUPE" },
    { id: "79", nombre: "GUAM" },
    { id: "80", nombre: "GUATEMALA" },
    { id: "81", nombre: "GUAYANA FRANCESA" },
    { id: "82", nombre: "GUERNSEY" },
    { id: "83", nombre: "GUINEA" },
    { id: "84", nombre: "GUINEA ECUATORIAL" },
    { id: "85", nombre: "GUINEA-BISSAU" },
    { id: "86", nombre: "GUYANA" },
    { id: "87", nombre: "HAITÍA" },
    { id: "88", nombre: "HONDURAS" },
    { id: "89", nombre: "HONG KONG" },
    { id: "90", nombre: "HUNGRÍA" },
    { id: "91", nombre: "INDIA" },
    { id: "92", nombre: "INDONESIA" },
    { id: "93", nombre: "IRAQ" },
    { id: "94", nombre: "IRLANDA" },
    { id: "95", nombre: "IRÁN" },
    { id: "96", nombre: "ISLA BOUVET" },
    { id: "97", nombre: "ISLA DE MAN" },
    { id: "98", nombre: "ISLA DE NAVIDAD" },
    { id: "99", nombre: "ISLANDIA" },
    { id: "100", nombre: "ISLAS CAIMÁN" },
    { id: "101", nombre: "ISLAS COCOS" },
    { id: "102", nombre: "ISLAS COOK" },
    { id: "103", nombre: "ISLAS FEROE" },
    { id: "104", nombre: "ISLAS GEORGIAS DEL SUR Y SANDWICH DEL SUR" },
    { id: "105", nombre: "ISLAS HEARD Y MCDONALD" },
    { id: "106", nombre: "ISLAS MARIANAS DEL NORTE" },
    { id: "107", nombre: "ISLAS MARSHALL" },
    { id: "108", nombre: "ISLAS PITCAIRN" },
    { id: "109", nombre: "ISLAS SALOMÓN" },
    { id: "110", nombre: "ISLAS TURCAS Y CAICOS" },
    { id: "113", nombre: "ISLAS ULTRAMARINAS DE ESTADOS UNIDOS" },
    { id: "111", nombre: "ISLAS VÍARGENES BRITÁNICAS" },
    { id: "112", nombre: "ISLAS VÍARGENES ESTADOUNIDENSES" },
    { id: "114", nombre: "ISRAEL" },
    { id: "115", nombre: "ITALIA" },
    { id: "116", nombre: "JAMAICA" },
    { id: "117", nombre: "JAPÓN" },
    { id: "118", nombre: "JERSEY" },
    { id: "119", nombre: "JORDANIA" },
    { id: "120", nombre: "KAZAJISTÁN" },
    { id: "121", nombre: "KENIA" },
    { id: "122", nombre: "KIRGUISTÁN" },
    { id: "123", nombre: "KIRIBATI" },
    { id: "124", nombre: "KUWAIT" },
    { id: "125", nombre: "LAOS" },
    { id: "126", nombre: "LESOTO" },
    { id: "127", nombre: "LETONIA" },
    { id: "128", nombre: "LIBERIA" },
    { id: "129", nombre: "LIBIA" },
    { id: "130", nombre: "LIECHTENSTEIN" },
    { id: "131", nombre: "LITUANIA" },
    { id: "132", nombre: "LUXEMBURGO" },
    { id: "133", nombre: "LÍABANO" },
    { id: "134", nombre: "MACAO" },
    { id: "135", nombre: "MADAGASCAR" },
    { id: "136", nombre: "MALASIA" },
    { id: "137", nombre: "MALAUI" },
    { id: "138", nombre: "MALDIVAS" },
    { id: "139", nombre: "MALTA" },
    { id: "141", nombre: "MARRUECOS" },
    { id: "142", nombre: "MARTINICA" },
    { id: "143", nombre: "MAURICIO" },
    { id: "144", nombre: "MAURITANIA" },
    { id: "145", nombre: "MAYOTTE" },
    { id: "146", nombre: "MICRONESIA" },
    { id: "147", nombre: "MOLDAVIA" },
    { id: "148", nombre: "MONGOLIA" },
    { id: "149", nombre: "MONTENEGRO" },
    { id: "150", nombre: "MONTSERRAT" },
    { id: "151", nombre: "MOZAMBIQUE" },
    { id: "152", nombre: "MYANMAR" },
    { id: "153", nombre: "MÉXICO" },
    { id: "154", nombre: "MÓNACO" },
    { id: "155", nombre: "NAMIBIA" },
    { id: "156", nombre: "NAURU" },
    { id: "157", nombre: "NEPAL" },
    { id: "158", nombre: "NICARAGUA" },
    { id: "159", nombre: "NIGER" },
    { id: "160", nombre: "NIGERIA" },
    { id: "161", nombre: "NIUE" },
    { id: "162", nombre: "NORFOLK" },
    { id: "163", nombre: "NORUEGA" },
    { id: "164", nombre: "NUEVA CALEDONIA" },
    { id: "165", nombre: "NUEVA ZELANDA" },
    { id: "166", nombre: "OMÁN" },
    { id: "167", nombre: "PAKISTÁN" },
    { id: "168", nombre: "PALAOS" },
    { id: "169", nombre: "PANAMÁ" },
    { id: "170", nombre: "PAPÚA NUEVA GUINEA" },
    { id: "171", nombre: "PARAGUAY" },
    { id: "172", nombre: "PAÍASES BAJOS" },
    { id: "173", nombre: "PERÚ" },
    { id: "174", nombre: "POLINESIA FRANCESA" },
    { id: "175", nombre: "POLONIA" },
    { id: "176", nombre: "PORTUGAL" },
    { id: "177", nombre: "PUERTO RICO" },
    { id: "178", nombre: "QATAR" },
    { id: "179", nombre: "REINO UNIDO" },
    { id: "180", nombre: "REPÚBLICA CENTROAFRICANA" },
    { id: "181", nombre: "REPÚBLICA CHECA" },
    { id: "184", nombre: "REPÚBLICA DE MACEDONIA" },
    { id: "185", nombre: "REPÚBLICA DEL CONGO" },
    { id: "182", nombre: "REPÚBLICA DEMOCRÁTICA DEL CONGO" },
    { id: "183", nombre: "REPÚBLICA DOMINICANA" },
    { id: "186", nombre: "REPÚBLICA ÁRABE SAHARAUI DEMOCRÁTICA" },
    { id: "188", nombre: "RUANDA" },
    { id: "189", nombre: "RUMANIA" },
    { id: "190", nombre: "RUSIA" },
    { id: "191", nombre: "SAINT-MARTIN" },
    { id: "192", nombre: "SAMOA" },
    { id: "193", nombre: "SAMOA AMERICANA" },
    { id: "194", nombre: "SAN BARTOLOMÉ" },
    { id: "195", nombre: "SAN CRISTÓBAL Y NIEVES" },
    { id: "196", nombre: "SAN MARINO" },
    { id: "197", nombre: "SAN PEDRO Y MIQUELÓN" },
    { id: "198", nombre: "SAN VICENTE Y LAS GRANADINAS" },
    { id: "199", nombre: "SANTA HELENA" },
    { id: "200", nombre: "SANTA LUCÍA" },
    { id: "201", nombre: "SAO TOMÉ Y PRINCIPE" },
    { id: "202", nombre: "SENEGAL" },
    { id: "203", nombre: "SERBIA" },
    { id: "204", nombre: "SEYCHELLES" },
    { id: "205", nombre: "SIERRA LEONA" },
    { id: "206", nombre: "SINGAPUR" },
    { id: "207", nombre: "SIRIA" },
    { id: "208", nombre: "SOMALIA" },
    { id: "209", nombre: "SRI LANKA" },
    { id: "210", nombre: "SUAZILANDIA" },
    { id: "211", nombre: "SUDÁFRICA" },
    { id: "212", nombre: "SUDÁN" },
    { id: "213", nombre: "SUECIA" },
    { id: "214", nombre: "SUIZA" },
    { id: "215", nombre: "SURINAM" },
    { id: "216", nombre: "SVALBARD Y JAN MAYEN" },
    { id: "217", nombre: "TAILANDIA" },
    { id: "218", nombre: "TAIWÁN" },
    { id: "219", nombre: "TANZANIA" },
    { id: "220", nombre: "TAYIKISTÁN" },
    { id: "221", nombre: "TERRITORIO BRITÁNICO DEL OCÉANO ÍANDICO" },
    { id: "222", nombre: "TERRITORIOS AUSTRALES FRANCESES" },
    { id: "223", nombre: "TERRITORIOS PALESTINOS" },
    { id: "224", nombre: "TIMOR ORIENTAL" },
    { id: "225", nombre: "TOGO" },
    { id: "226", nombre: "TOKELAU" },
    { id: "227", nombre: "TONGA" },
    { id: "228", nombre: "TRINIDAD Y TOBAGO" },
    { id: "229", nombre: "TURKMENISTÁN" },
    { id: "230", nombre: "TURQUÍA" },
    { id: "231", nombre: "TUVALU" },
    { id: "232", nombre: "TÚNEZ" },
    { id: "233", nombre: "UCRANIA" },
    { id: "234", nombre: "UGANDA" },
    { id: "235", nombre: "URUGUAY" },
    { id: "236", nombre: "UZBEKISTÁN" },
    { id: "237", nombre: "VANUATU" },
    { id: "238", nombre: "VENEZUELA" },
    { id: "239", nombre: "VIETNAM" },
    { id: "240", nombre: "WALLIS Y FUTUNA" },
    { id: "241", nombre: "YEMEN" },
    { id: "242", nombre: "YIBUTI" },
    { id: "243", nombre: "ZAMBIA" },
    { id: "244", nombre: "ZIMBABUE" },
  ]);

  const getAll = () => nacionalities.value;

  const getByNombre = (nombre) => {
    if (!nombre) return null;

    const nacionalidad = nacionalities.value.find(
      (n) => n.nombre.toUpperCase() === nombre.toUpperCase()
    );

    return nacionalidad ? nacionalidad.id : null;
  };

  return {
    nacionalities,
    getAll,
    getByNombre,
  };
});
